var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDsIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#E7EDFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_761_38445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.786 34.4511C36.7713 34.4511 38.4904 33.739 39.895 32.3342C41.2997 30.9295 42.0117 29.2109 42.0117 27.2253C42.0117 25.2405 41.2997 23.5216 39.8948 22.1165C38.4899 20.712 36.771 20 34.786 20C32.8004 20 31.0817 20.712 29.6771 22.1167C28.2725 23.5213 27.5602 25.2402 27.5602 27.2253C27.5602 29.2109 28.2725 30.9298 29.6773 32.3344C31.0822 33.7388 32.8011 34.4511 34.786 34.4511Z",
    fill: "#396AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4291 43.0685C47.3886 42.484 47.3066 41.8463 47.186 41.1729C47.0642 40.4945 46.9075 39.8532 46.7198 39.267C46.5259 38.6612 46.2623 38.0629 45.9363 37.4896C45.598 36.8945 45.2007 36.3763 44.7548 35.9499C44.2886 35.5038 43.7178 35.1451 43.0577 34.8835C42.3999 34.6233 41.6709 34.4914 40.8911 34.4914C40.5849 34.4914 40.2887 34.6171 39.7167 34.9895C39.3647 35.2191 38.9529 35.4846 38.4933 35.7782C38.1004 36.0286 37.568 36.2632 36.9104 36.4756C36.2689 36.6832 35.6175 36.7885 34.9745 36.7885C34.3316 36.7885 33.6804 36.6832 33.0382 36.4756C32.3813 36.2634 31.8489 36.0288 31.4564 35.7784C31.0012 35.4875 30.5892 35.222 30.2319 34.9893C29.6606 34.6169 29.3642 34.4912 29.058 34.4912C28.2779 34.4912 27.5492 34.6233 26.8916 34.8837C26.232 35.1449 25.6609 35.5036 25.1942 35.9501C24.7486 36.3767 24.351 36.8947 24.0132 37.4896C23.6875 38.0629 23.4238 38.661 23.2297 39.2673C23.0423 39.8534 22.8855 40.4945 22.7637 41.1729C22.6431 41.8454 22.5612 42.4833 22.5207 43.0692C22.4808 43.6432 22.4607 44.239 22.4607 44.8407C22.4607 46.4067 22.9585 47.6745 23.9402 48.6095C24.9097 49.5321 26.1926 50.0002 27.7526 50.0002H42.1978C43.7578 50.0002 45.0403 49.5323 46.01 48.6095C46.9919 47.6752 47.4897 46.4072 47.4897 44.8405C47.4895 44.236 47.4691 43.6398 47.4291 43.0685Z",
    fill: "#396AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_761_38445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.9999,
    height: 30,
    fill: "white",
    transform: "translate(19.9998 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsIcon01);
export default __webpack_public_path__ + "static/media/ds_icon_01.12510b71c92d9ce04f869e91f7236324.svg";
export { ForwardRef as ReactComponent };